
import {
  Home,
  UserCircle,
  History,
  ThumbsUp,
  Settings,
  LogOut,
  FileInput,
  BarChart,
  Activity,
  Heart,
  Shield,
  User,
  MessageCircle,
  Mic,
  Brain,
  UserPlus,
  BarChart3,
  ExternalLink,
  Bug
} from 'lucide-react';
import { LucideIcon } from 'lucide-react';

interface NavItem {
  icon: LucideIcon;
  label: string;
  path: string;
  external?: boolean;
}

// Main navigation items
export const mainNavItems: NavItem[] = [
  { icon: Home, label: "Início", path: "/app" },
  { icon: UserCircle, label: "Perfil", path: "/perfil" },
  { icon: FileInput, label: "Registro", path: "/registro" },
  { icon: Heart, label: "Emoções", path: "/emocoes" },
  { icon: Activity, label: "Desempenho", path: "/desempenho" },
  { icon: Mic, label: "Terap-IA", path: "/agente-voz" },
  { icon: BarChart, label: "Meditações", path: "/meditacoes" },
  { icon: MessageCircle, label: "Comunidade", path: "/community" },
  { icon: Brain, label: "Testes de Personalidade", path: "/testes-personalidade" },
  { icon: User, label: "Jornadas", path: "/jornadas" },
  { icon: BarChart3, label: "Análise Avançada", path: "/analise-avancada" },
  { icon: UserPlus, label: "Indique e Ganhe", path: "/indicacoes" },
  { icon: Shield, label: "Compliance", path: "/corporativo/compliance" },
  { icon: Bug, label: "Debug Seshs", path: "/debug-seshs" },
  { icon: History, label: "Histórico", path: "/historico" },
  { icon: ThumbsUp, label: "Feedback", path: "/feedback" },
];

// Bottom navigation items - footer menu
export const bottomNavItems: NavItem[] = [
  { icon: ExternalLink, label: "Voltar ao Site", path: "/landing", external: true },
  { icon: Settings, label: "Configurações", path: "/configuracoes" },
  { icon: LogOut, label: "Sair", path: "/sair" },
];

// Debug: Log the bottom nav items to console
console.log("Bottom navigation items:", bottomNavItems);
